import EmptyState from "ds/components/EmptyState";
import { EmptystateShareColored } from "components/icons/generated";
import Box from "ds/components/Box";

const UserIntegrationsEmpty = () => {
  return (
    <Box align="center" justify="center" grow="1">
      <EmptyState title="You don’t have any integrations yet" icon={EmptystateShareColored} />
    </Box>
  );
};

export default UserIntegrationsEmpty;
